<template>
  <div style="margin: 0.8rem">
    <!-- <div class="my-head">
            <div style="margin: 1rem 0;font-size: 1.1rem" class="van-ellipsis">{{head.topic}}</div>
            <img v-if="head.imgmin" :src="head.imgmin" class="my-head-img" @click="toDetail(head)"/>
            <div class="date van-hairline--bottom">时间：{{head.postDate}}</div>
        </div> -->
    <div @click="showPopup">
      <div style="display: inline-block">
        <van-icon
          style="line-height: 20px; vertical-align: middle"
          name="descending"
        />{{
          filterYears ? `${filterYears}年${filterMonth}月之前` : "按时间筛选"
        }}
      </div>
      <span style="float: right">总计:{{ total }}条</span>
    </div>
    <van-popup
      v-model="timeFilterTrigger"
      get-container="body"
      position="bottom"
      :safe-area-inset-bottom="true"
      :style="{ width: '100%' }"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :formatter="formatter"
        @confirm="filterNewsList"
        @cancel="timeFilterTrigger = false"
    /></van-popup>

    <home-call
      v-for="(v, i) in callList"
      :key="i"
      :tilde="v.topic"
      :post-date="v.postDate"
      :sub-tilde="v.briefIntroduction"
      @click="toDetail(v)"
      :img="v.imgmin"
    />
    <my-btn :value="showPage ? '加载更多' : '没有更多'" @click="evenMore" />
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
import homeCall from "../../common/homeCall";
import homeList from "../../common/homeList";
import myBtn from "../../common/myBtn";
import service from "../../api/service";

export default {
  name: "homeB",
  components: {
    Swipe,
    SwipeItem,
    homeCall,
    homeList,
    myBtn,
  },
  props: {
    activityId: "",
  },
  data() {
    return {
      baseURLB: service.baseURLB,
      head: {},
      callList: [],
      pageIndex: 1,
      showPage: true,
      currentDate: new Date(),
      timeFilterTrigger: false,
      total: 0,
      filterYears: null,
      filterMonth: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    showPopup() {
      this.timeFilterTrigger = true;
      console.warn(this.timeFilterTrigger);
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    init() {
      let params = {
        id: this.activityId,
        page: this.pageIndex,
        size: 10,
        year: this.filterYears,
        month: this.filterMonth,
      };

      if (!params.year) delete params.years;
      if (!params.month) delete params.month;

      service.get("/api/xw/getNewsListByColumnID", params).then((res) => {
        if (res.status === 200) {
          if (res.data.length === 0) {
            this.showPage = false;
            return;
          }
          // if (Object.keys(this.head).length === 0) {
          //     this.head = res.data[0]
          //     res.data.shift()
          // }
          this.callList = this.callList.concat(res.data);
          this.total = res.total;
        }
      });
    },
    filterNewsList(e) {
      console.warn(e.getFullYear(), e.getMonth());
      this.filterYears = e.getFullYear();
      this.filterMonth = e.getMonth() + 1;

      this.timeFilterTrigger = false;

      this.callList = [];
      this.pageIndex = 1;
      this.showPage = true;

      this.init();
    },
    toDetail(row) {
      sessionStorage.setItem("row", JSON.stringify(row));
      this.$router.push({
        path: "/xwDetail",
        query: { sourcePath: "/home", contentId: row.contentid },
      });
    },
    //更多
    evenMore() {
      this.pageIndex += 1;
      this.init();
    },
  },
};
</script>

<style scoped>
.my-head {
}

.date {
  font-size: 0.8rem;
  padding: 0.8rem 0;
  color: rgb(175, 175, 175);
}

.my-head-img {
  width: 100%;
}

</style>